import {Injectable} from '@angular/core';

import {STORAGE_KEY} from '@app/core/config/app.config';
import {YearsAtAlpha} from '@app/core/models/years-at-alpha.model';
import {YearsAtAlphaService} from '@app/core/services/years-at-alpha/years-at-alpha.service';

import {BehaviorSubject} from 'rxjs';

const DEFAULT      = '2+';
const ALL_SELECTED = 'ALL';

@Injectable({providedIn: 'root'})
export default class AlphaYearsState {
  private readonly _allEnabled$   = new BehaviorSubject<boolean>(false);
  private readonly _selected$     = new BehaviorSubject<string>(this.getDefault());
  public selected$                = this._selected$.asObservable();
  private readonly _yearsAtAlpha$ = new BehaviorSubject<YearsAtAlpha[]>([]);
  public yearsAtAlpha$            = this._yearsAtAlpha$.asObservable();

  constructor(private readonly _service: YearsAtAlphaService) {
    this._service.yearsAtAlpha$.subscribe(data => this.updateYears(data));
  }

  /** Enables option to select All Years At Alpha */
  public enableAll(value: boolean): void {
    this._allEnabled$.next(value);
    if (value) {
      this.updateYear(ALL_SELECTED);
    } else {
      this.updateYear(DEFAULT);
    }
  }

  public getDefault(): string {
    return localStorage.getItem(STORAGE_KEY.yearAtAlpha) && localStorage.getItem(STORAGE_KEY.yearAtAlpha) !== 'ALL'
      ? localStorage.getItem(STORAGE_KEY.yearAtAlpha)
      : DEFAULT;
  }

  public updateYear(value: string, global = true): void {
    this._selected$.next(value);
    if (global) {
      localStorage.setItem(STORAGE_KEY.yearAtAlpha, value);
    }
  }

  public updateYears(values: YearsAtAlpha[]): void {
    this._yearsAtAlpha$.next(values);
  }
}
